import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-backtop',
  templateUrl: './backtop.component.html',
  animations: [
    trigger('visibilityAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('600ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('600ms', style({ opacity: 0 })),
      ]),
    ]),
  ],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacktopComponent {
  protected isVisible = false;

  private pageYOffset = 0;

  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    this.pageYOffset = window.pageYOffset;
    this.showScrollTop();
  }

  showScrollTop(): void {
    this.isVisible = this.pageYOffset > 600;
  }

  scrollTop(): void {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
